import { defineComponent, ref, watchEffect } from 'vue';
import { useElementDimensions } from '../../../../composables/dom.js';
import '@caresend/utils';
import '@caresend/types';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../../router/helpers/initRouter.js';

var script = defineComponent({
    name: 'ResizeObserver',
    props: {
        isComponent: {
            type: [Function, Object, String],
            default: 'div',
        },
    },
    emits: ['resize'],
    setup(_, { emit }) {
        const element = ref(null);
        const { height, width } = useElementDimensions(element);
        watchEffect(() => {
            emit('resize', { height: height.value, width: width.value });
        });
        return { element };
    },
});

export { script as default };
